/**
 * Storage
 */

class Storage {
    get(name) {
        return sessionStorage.getItem(name)
    }

    set(name, value) {
        return sessionStorage.setItem(name, value)
    }

    remove(name) {
        return sessionStorage.removeItem(name)
    }

    clear() {
        return sessionStorage.clear()
    }

    getToken(){
        let token = '';
        let arr, reg = new RegExp("(^| )" + 'accessToken' + "=([^;]*)(;|$)"); //正则匹配
        if (arr = document.cookie.match(reg)) {
            token = unescape(arr[2]);
        }
        return token;
    }
}

export default new Storage()
